<template>
    <div class="movimentos_ods">
        <div class="row">
            <public-header :title="'Movimento ODS Santos 2030'">
                <div class="col-xs-12 col-sm-6">
                    <div class="subheader">
                        O Movimento ODS Santos 2030 é um coletivo entre sociedade civil organizada, iniciativa privada e administração pública e serve como ponto de partida de uma nova fase para o desenvolvimento sustentável da Cidade. Iniciativa da Prefeitura de Santos e Associação Comercial de Santos.
                    </div>
                </div>
            </public-header>
        </div>
        <div class="container" style="padding-top: 15px">
            <div class="row">
                <ol class="breadcrumb">
                    <li><router-link :to="'/'">Início</router-link></li>
                    <li class="">Movimentos ODS</li>
                </ol>
            </div>

            <div class="col-xs-12">
                <div class="row" style="margin-bottom: 30px;">

                </div>
                <div class="row">
                    <!-- <div class="col-xs-10 col-xs-offset-1">
                        <div class="input-group filtro-pesquisa">
                            <input type="text" class="form-control" v-model="filtros" placeholder="Filtrar pesquisa..." />
                            <span class="input-group-btn">
                                <button class="btn btn-default" @click="add('termo_pesquisa', filtros)">
                                    <font-awesome-icon :icon="'search'" />
                                </button>
                            </span>
                        </div>
                    </div> -->
                    <div class="col-xs-12">
                        <data-table-public ref="dt" :has-auth="false" title="Movimentos ODS" api-url="movimentos-ods"
                            :show-empty="true" :fields="fields" data-path="" :paginationInfoShow="false">
                            <template slot="icon" slot-scope="props">
                                <img v-for="({ titulo, img }) in listBandeirasInfo(props.rowData.bandeiras)" :src="img"
                                    :title="titulo" :alt="titulo">
                            </template>
                            <template slot="rowrender" slot-scope="props">
                                <button type="button" class="btn btn-primary" title="Mais informações" 
                                @click="maisInformacoes(props.rowData)">
                                    <font-awesome-icon :icon="'info'" />
                                </button>
                            </template>
                        </data-table-public>
                    </div>
                </div>
            </div>
        </div>

        <!-- ModalMovimentoInfo -->
        <modal-movimento-info ref="modalInfo" />
    </div>
</template>
  
<script>
import { PublicHeader } from '../../../components/common/'
import DataTablePublic from '@/components/common/DataTablePublic'
import ModalMovimentoInfo from '../../../components/ODS/ModalMovimentoInfo.vue'

export default {
    components: { PublicHeader, DataTablePublic, ModalMovimentoInfo },
    data() {
        return {
            filtros: '',
            fields: [
                { name: 'titulo', title: 'Título' },
                { name: 'instituicao', title: 'Instituição' },
                { name: 'inicio', title: 'Inicio' },
                { name: 'encerramento', title: 'Encerramento', dataClass: 'nowrap' },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-1',
                    dataClass: 'text-center'
                }
            ]
        }
    },
    methods: {
        maisInformacoes(data) {
            this.$refs.modalInfo.show({ 
                instituicao: data.instituicao, 
                titulo: data.titulo, 
                dataInicio: data.inicio, 
                dataEncerramento: data.encerramento,
                local: data.local,
                descricao: data.descricao,
                totalParticipantes: data.total_participantes_esperado,
                tipo_acao: data.tipo_acao,
                bandeiras: data.bandeiras,
                link_instrucoes: data.link_instrucoes,
                link_fotos: data.link_fotos
             })
        }
    }
}
</script>
  
<style>

td img {
    width: 32px;
    margin-right: 2px;
    margin-top: 2px;
}

td.nowrap {
  white-space: nowrap;
}

.filtro-pesquisa input,
.filtro-pesquisa button {
    height: 50px;
    margin-bottom: 30px;
}

.filtro-pesquisa i {
    font-size: 1.3em;
}
</style>
  


// WEBPACK FOOTER //
// src/views/public/movimentos_ods/index.vue